import { render } from "./AcessoNegado.vue?vue&type=template&id=66cd029e"
import script from "./AcessoNegado.vue?vue&type=script&lang=ts"
export * from "./AcessoNegado.vue?vue&type=script&lang=ts"
script.render = render

export default script